import { useEffect } from 'preact/hooks';
import srv from '@/index';
import { useConfigStore, useFormProps } from '../stores/ConfigStore';
import { useBlockStore } from '../stores/BlockStore';

export default function useSyncExternal({
	formType,
	formOpen,
	isMultiple,
	multipleIndex
}) {
	const { formKey } = useFormProps();
	const { actions: configActions, ...config } = useConfigStore();
	const { actions: blockActions, ...state } = useBlockStore();
	useEffect(() => {
		try {
			if (isMultiple) {
				if (!srv[formKey]._multiple) {
					srv[formKey]._multiple = [];
				}
				srv[formKey]._multiple[multipleIndex] = {
					_state: state
				};
				srv[formKey]._formOpen = formOpen;
				srv[formKey]._formType = formType;
				srv[formKey]._config = config;
			} else {
				srv[formKey]._formOpen = formOpen;
				srv[formKey]._formType = formType;
				srv[formKey]._config = config;
				srv[formKey]._state = state;
			}
		} catch (e) {}
	}, [formOpen, formType, formKey, config, state, isMultiple, multipleIndex]);
}
